/**
 * Controller: GroupsRemoveModal
 */
angular.module('acme.view.application.groups.users.removeModal.controllers', [])
.controller('GroupsUsersRemoveModalController', [ '$scope', '$uibModalInstance', 'currentUser', function ($scope, $uibModalInstance, currentUser) {

    $scope.errors = [];

    $scope.model = {
      id: currentUser.id,
      name: currentUser.firstName + ' ' + currentUser.lastName,
      email: currentUser.email
    };

    $scope.init = function() {

    };

    $scope.hasErrors = function() {
      return ($scope.errors.length > 0);
    };

    $scope.done = function() {
      $scope.success();
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.success = function () {
      $uibModalInstance.close(true);
    };

    $scope.init();

  }]);